<template>
  <button
      :disabled="disabled"
      :class="[
            {
                'bg-primary disabled:bg-opacity-50 hover:enabled:bg-opacity-50 base-button-text-color': type === 'base',
                'bg-neutral-900 text-white disabled:bg-neutral-900/30 hover:bg-opacity-50': type === 'neutral',
                'bg-red-600 text-white border border-red-600 disabled:text-primary/40 disabled:border-primary/40': type === 'red-primary',
                'bg-white border border-neutral-300 text-red-600 disabled:text-primary/40 disabled:border-primary/40 sm:hover:bg-neutral-100': type === 'red-secondary',
                'bg-red-50 border border-red-600': type === 'red-tirtiary',
                'bg-transparent border border-neutral-300 text-neutral-900 hover:bg-neutral-100': type === 'transparent',
                'bg-transparent border border-neutral-300 text-neutral-500 ': type === 'transparent-secondary',
                'bg-white border border-neutral-300 text-neutral-700 hover:bg-neutral-100': type === 'white',
                'bg-black text-white': type === 'black',
            },
            round ? 'rounded-full' : 'rounded-lg',
            loading? 'text-opacity-25' : '',
            fit? '!w-fit !px-4 !py-1' : '',
        ]"
      class="relative flex w-full items-center justify-center px-5 py-3 md:py-4 font-medium transition-all duration-300 md:px-12 text-base shadow-none focus-visible:ring-0 focus-visible:shadow-none focus-visible:ring-offset-0 ring-offset-0 ring-0 disabled:cursor-not-allowed">
      <BaseIcon v-if="loading" class="absolute h-6 w-6 text-white" :class="[
            {
                '!text-neutral-900': type === 'transparent',
            },
        ]" :style="type === 'base' ? {'color': baseTextColor} : {}" name="loading"/>
      <span v-if="loading">&nbsp;</span>
      <slot></slot>
  </button>
</template>
<script setup lang="ts">
import { useCheckoutStore } from '~/store/checkout';

defineProps({
  type: {
    type: String,
    default: 'base'
  },
  round: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  fit: {
    type: Boolean,
    default: false
  }
})
const event = useCheckoutStore().$state.event;
const baseTextColor = useContrastValidator(event.media.color)
</script>
<style scoped>
.base-button-text-color {
  color: v-bind(baseTextColor);
}
</style>
